import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {percentageFormatter} from '../../helpers/formatters';

interface IYearOfCompanyProps {
    submissions: any[];
}

const YearOfCompany = ({submissions}: IYearOfCompanyProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        let values = submissions.map((submission) => submission.question2);
        values = values.filter((value) => value !== null && value !== '');

        let data: {name: string, y: number}[] = [];

        values.forEach((value: any) => {
            const year = value.toString();
            const index = data.findIndex((item: any) => item.name === year);

            if (index === -1) {
                data.push({name: year, y: 1});
            } else {
                data[index].y += 1;
            }
        });

        data = data.sort((a, b) => a.name.localeCompare(b.name));

        const dashboardOptions: Highcharts.Options = {
            chart: {
                type: 'column',
            },
            title: {
                text: 'Year of company establishment',
                align: 'left',
            },
            yAxis: {
                min: 0,
                title: {
                    text: '',
                },
            },
            xAxis: {
                categories: data.map((el) => el.name),
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
            },
            series: [
                {
                    showInLegend: false,
                    name: 'Number',
                    data: data.map((el) => el.y),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        formatter: percentageFormatter(data),
                    },
                },
            ],
        };

        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default YearOfCompany;
